import en from './en.js'
import dutch from './dutch.js'

export default {
  'en-GB':en,
  'nl-BE': dutch
}